import React from "react";
import useDocumentosEstudiante from "../hooks/useDocumentosEstudiante";
import DocumentosPanel from "./DocumentosPanel";
import { usePermissions } from "../../../../utils/permissions";

export default function DocumentosTab({ estudianteId, estudiante, documentosData }) {
  const hookDocs = useDocumentosEstudiante(estudianteId);
  const docs = documentosData || hookDocs;
  const { hasPermission } = usePermissions();
  const canManageDocs = hasPermission("estudiantes.actualizar") || hasPermission("estudiantes.crear");
/*   const hasDocumentoIdentidad = (docs.documentos || []).some((doc) => doc.tipo === "documento_identidad");
 */
  return (
    <div className="doc-panel">
      <h6 className="mb-3">Documentos del estudiante</h6>
      {/* {!hasDocumentoIdentidad && (
        <div className="alert alert-warning">
          Debe subir el documento de identidad.
        </div>
      )} */}
      <DocumentosPanel
        seleccionado={estudiante}
        documentos={docs.documentos}
        loadingDocs={docs.loadingDocs}
        docsError={docs.docsError}
        uploading={docs.uploading}
        handleSubir={docs.handleSubir}
        handleEliminarDoc={docs.handleEliminarDoc}
        getVerUrl={docs.getVerUrl}
        getDescargarUrl={docs.getDescargarUrl}
        handleCambiarEstado={docs.handleCambiarEstado}
        handleMarcarNoAplica={docs.handleMarcarNoAplica}
        handleRetryAnalisis={docs.handleRetryAnalisis}
        handleVerAnalisis={docs.handleVerAnalisis}
        retryingAnalisis={docs.retryingAnalisis}
        canUpload={canManageDocs}
        canDelete={canManageDocs}
      />
    </div>
  );
}
